import React from 'react'
import "./About.css"
function About() {
  return (
    <>
  <div class="container py-3 about_heading">
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center mb-2">About Us</h1>
      <p>Welcome to Nest Jec, a vibrant and holistic community dedicated to nurturing the growth and development of young minds through culture, education, and spiritual well-being. Situated in the heart of Jabalpur, our facility offers a range of services and amenities designed to foster a supportive and enriching environment for students and young professionals.</p>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-md-12">
      <h2 class="text-center mb-4">Our Facilities</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-4">
      <h3>ISKCON BACE (Bhaktivedanta Academy for Culture & Education)</h3>
      <p>At ISKCON BACE, we aim to instill values of love, compassion, truthfulness, humility, simplicity, and non-envy in young boys, who are the future of society. Our programs focus on the study of Vedic literature and the practice of Krishna consciousness, providing a foundation for personal and spiritual growth.</p>
    </div>
    <div class="col-md-6 mb-4">
      <h3>Jagannath Kitchen</h3>
      <p>Our Jagannath Kitchen serves delicious and nutritious prasaadam, sanctified food offered to Lord Jagannath. This facility ensures that all residents and visitors receive wholesome meals that nourish both the body and the soul.</p>
    </div>
  </div>

  

  <div class="row mt-5" data-aos="fade-up">
    <div class="col-md-12">
      <h2 class="text-center mb-4">Additional Features</h2>
    </div>
  </div>

  <div class="row" data-aos="fade-up">
    <div class="col-md-6 mb-4">
      <h4>Educational Programs</h4>
      <p>Regular classes and workshops on Vedic studies, life skills, and personal development.</p>
    </div>
    <div class="col-md-6 mb-4" data-aos="fade-up">
      <h4>Cultural Activities</h4>
      <p>Festivals, kirtans, and other cultural events to enrich the spiritual and cultural experience.</p>
    </div>
  </div>

  <div class="row" data-aos="fade-up">
    <div class="col-md-6 mb-4">
      <h4>Mentorship and Guidance</h4>
      <p>Access to mentors and spiritual guides who provide support and advice for personal and academic challenges.</p>
    </div>
    <div class="col-md-6 mb-4" data-aos="fade-up">
      <h4>Community Service</h4>
      <p>Opportunities to engage in various service activities that benefit the broader community and foster a spirit of giving and compassion.</p>
    </div>
  </div>

  
</div>

  </>
  )
}

export default About
